import {BroadcastChannel} from "broadcast-channel"

const DocoonBroadCastCanel = new BroadcastChannel("docoon")

export const logOut = (callback: Function) => {
    DocoonBroadCastCanel.postMessage("logout")
    callback()
    DocoonBroadCastCanel.close()
}

export const ChaneRoleBoradCast = (callback: Function) => {
    DocoonBroadCastCanel.postMessage("changerole")
    callback()
}
export const ChangeLangue = () => {
    DocoonBroadCastCanel.postMessage("changerole")
}
export const Refreshe = (callback: Function) => {
    DocoonBroadCastCanel.postMessage("Refreshe")
    callback()
}

export const DocoonBroaCastChanel = () => {
    return new Promise<string>((resolve, reject) => {
        DocoonBroadCastCanel.onmessage = async (msg: string) => {
            resolve(msg)
        }
    })
}
